import { render, staticRenderFns } from "./ModuleReport.vue?vue&type=template&id=6ae42498&scoped=true&"
import script from "./ModuleReport.vue?vue&type=script&lang=js&"
export * from "./ModuleReport.vue?vue&type=script&lang=js&"
import style0 from "./ModuleReport.vue?vue&type=style&index=0&id=6ae42498&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae42498",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
